import React from "react";
import MaskedDateInput from "../components/MaskedDateInput";
import { FinancingFormValues } from "../utils/validateFinancingForm";
import AmortizationSystemToggle from "./AmortizationSystemToggle";

const inputClassName =
  "rounded-xl border border-white/[0.08] bg-[#0d1117] px-3 py-2.5 text-sm text-[#f0f6fc] outline-none focus:border-[#6ea8ff]/50";

interface FinancingFormFieldsProps {
  values: FinancingFormValues;
  onChange: <K extends keyof FinancingFormValues>(
    field: K,
    value: FinancingFormValues[K]
  ) => void;
}

export default function FinancingFormFields({ values, onChange }: FinancingFormFieldsProps) {
  return (
    <>
      <AmortizationSystemToggle
        value={values.amortizationSystem}
        onChange={(nextValue) => onChange("amortizationSystem", nextValue)}
      />

      <label className="flex flex-col gap-1.5 text-sm text-[#8b949e]">
        Data de início dos pagamentos
        <MaskedDateInput
          value={values.paymentStartDateDisplay}
          onChange={(nextValue) => onChange("paymentStartDateDisplay", nextValue)}
          required
        />
      </label>

      {values.amortizationSystem === "price" ? (
        <label className="flex flex-col gap-1.5 text-sm text-[#8b949e]">
          Parcela mensal (R$)
          <input
            type="text"
            inputMode="decimal"
            placeholder="3500"
            value={values.monthlyInstallment}
            onChange={(event) => onChange("monthlyInstallment", event.target.value)}
            className={inputClassName}
          />
        </label>
      ) : (
        <>
          <label className="flex flex-col gap-1.5 text-sm text-[#8b949e]">
            Valor financiado (R$)
            <input
              type="text"
              inputMode="decimal"
              placeholder="240000"
              value={values.financedAmount}
              onChange={(event) => onChange("financedAmount", event.target.value)}
              className={inputClassName}
            />
          </label>
          <label className="flex flex-col gap-1.5 text-sm text-[#8b949e]">
            Taxa de juros anual (%)
            <input
              type="text"
              inputMode="decimal"
              placeholder="9,5"
              value={values.annualInterestRatePct}
              onChange={(event) => onChange("annualInterestRatePct", event.target.value)}
              className={inputClassName}
            />
          </label>
          <label className="flex flex-col gap-1.5 text-sm text-[#8b949e]">
            Número de parcelas
            <input
              type="number"
              min={1}
              placeholder="360"
              value={values.installmentCount}
              onChange={(event) => onChange("installmentCount", event.target.value)}
              className={inputClassName}
            />
          </label>
        </>
      )}
    </>
  );
}
